<template lang="pug">
.bottom-container
  .open-gift(v-if="giftList&&giftList.length>0")
    .open-gift-left
      .open-gift-title
        .open-gift-icon
        .open-gift-word 开卡礼
        .open-gift-img(@click="goRule")
          img(src="https://m.hellobike.com/resource/gallery/61/mGIQSMIae2.png?x-oss-process=image/quality,q_80")
      .open-gift-subtitle
        .open-gift-text 开通后
        .open-gift-redText 免费任选1件
    .open-gift-list(:style="amtWidth(giftList)")
      .list-item(
        :key="index"
        v-for="(item,index) in giftList"
        :style="amtDelay(giftList,index)")
        .list-img
          img(:src="item.displayPic")
  //- 抖音支付优惠文案
  .tiktok-pay-box(
    v-if="isOneCentRide && !isUpgrade")
    img.tiktok-icon(src="https://m.hellobike.com/a15bcda7_Vector.png")
    .tiktok-content
      img.tiktok-discount-title(src="https://m.hellobike.com/2fc4040bcb.png")
      .tiktok-discount-content
        .discount-text 首月补贴
        HighlightText.discount-price(
          text="最高{9}元"
          :normalStyle="normalStyle"
          :highlightStyle="highlightStyle"
        )
  .vip-button-new-container(
    :class='classes'
    v-if="unOpenShowCanBuy"
  )
    //- 连续包月支付渠道
    .tab-box(
      v-if="signPayChannelsList && signPayChannelsList.length && !isOneCentRide"
      :class="isEnhanceStyle?'continuous-enhanceStyle':'continuous-channel-tab'"
    )
      .desc-text {{isEnhanceStyle?'支付方式': '连续包月签约方式'}}
      .channel-button(v-for="(item,index) in signPayChannelsList"
                      :class="{'selected-channel':payChannel === item.channelCode}"
                      @click="changeContinuePayChannel(item)")
        img.channel-button-icon(:src="item.channelLogo")
        .channel-button-name {{item.channelName}}
        .channel-button-tip(
          v-if="item.payActivityInfo && item.payActivityInfo.promptText && isEnhanceStyle"
        ) {{item.payActivityInfo.promptText}}
    //- 开通一个月/连续包月主按钮
    .trans-tab
      .trans-left(@click="buy(false)")
        .trans-left-one
          span  {{isUpgrade?'立即升级':'开通1个月'}}
          span.red-sign ¥
          span.red-money {{(info.current||0)*1}}
        .trans-left-two 日常价¥{{info.original*1||'-'}}
      .trans-right(@click="buy(true)")
        //- 倒计时
        .countdown-wrapper(v-if="isUpgrade")
          FlexibleCountdown.count-down(
            type='daily'
            :blockStyle="timeBlockStyle"
            :separatorStyle="timeSeparatorStyle")
          .expire-text 后失效
        .trans-right-one
          span 连续包月
          span.sign ¥
          span.big-money {{info.signInfoDTO?info.signInfoDTO.firstSignPrice:'-'}}
        .trans-right-two 次月起 {{info.signInfoDTO?info.signInfoDTO.secondSignPrice:'-'}}/月续费
        //- 抖音一分骑优惠后价格tip
        .one-cent-tip(v-if="oneCentTip > 0 && !isUpgrade")
          .one-cent-tip-text 抖音补贴后
          .one-cent-tip-amount {{oneCentTip}}
          .one-cent-tip-text 起
    //- 规则协议
    .renewal-rules
      div(style="display:flex")
        div(v-if="isNoSign" @click="sign")
          img.rule-word-img(src="https://m.hellobike.com/resource/helloyun/08345/37EqW_CTt-.png")
        div(v-else @click="sign")
          img.rule-word-img(src="https://m.hellobike.com/resource/helloyun/08345/JJ8LaMe1nV.png")
        span.normal 已阅读并同意
        span.canClick(@click="goMember") 《哈啰会员服务协议》
        span.normal 与
        span.canClick(@click="goRenewal")  《自动续费协议》
  //- 即将上线的会员版本 不可点击
  .vip-button-no(v-else :class='classes')
    .vip-button-img
      img(src="https://m.hellobike.com/resource/helloyun/08345/8XyN4dNsht.png?x-oss-process=image/quality,q_80")
    .vip-button-block
      .vip-left-button
        .trans-left-one
          span 开通一个月
          span.sign ¥
          span.big-money {{info.current*1}}
        .trans-left-two 日常价¥{{info.original*1||'-'}}
      .vip-right-button
        .trans-right-one
          span 连续包月
          span.sign ¥
          span.big-money {{info.signInfoDTO?info.signInfoDTO.firstSignPrice:'-'}}
        .trans-right-two 次月起 {{info.signInfoDTO?info.signInfoDTO.secondSignPrice:'-'}}/月续费
</template>
<script>
import Picture from '@/components/picture';
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { sub } from '@/utils';
import { Storage } from '@/utils/storage';
import eventBus from '@/const/eventBus.js';
import Toast from '@/components/toast';
import { Navigator } from '@hb/h5-navigator';
import { applyDynamicKeyframes } from '@/utils/liveAnimation';
import {
  getSignChannels,
} from '@/api/vip';
import { HighlightText } from '@hb/platformui-h5';
import { PropVersionMap } from '@/const/vip';
import { getSource, getTokenAndKey } from '../../../../utils';
import { getSystemCode, getVersion } from '../../../../utils/systemCode';
import { ORDER_TYPE } from '../../consts';
import FlexibleCountdown from './new-member/flexible-countdown.vue';

export default {
  components: {
    Lottie,
    Picture,
    HighlightText,
    FlexibleCountdown,
  },
  props: {
    isNba: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: null,
    },
    readSign: {
      type: Boolean,
      default: false,
    },
    isIndex: {
      type: Boolean,
      default: true,
    },
    unOpenShowCanBuy: {
      type: Boolean,
      required: true,
    },
    giftList: {
      type: Array,
      default: () => [],
    },
    propVersion: {
      type: String,
      default: '',
    },
    // 是否是单车卡升级
    isUpgrade: {
      type: Boolean,
      default: false,
    },
    hasRemainDays: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    getSignPayChannels: {
      default: () => () => [], // 这里必须返回一个函数，否则会报错
    },
    rideOneCentVersion: {
      default: () => '',
    },
  },
  data() {
    return {
      classes: {
        show: false,
        fixed: false,
      },
      loadingPay: false,
      env,
      timer: null,
      timeout: null,
      allMonth: true,
      isNoSign: true,
      payChannel: this.defaultPayChannel,
      signPayChannelsList: [],
      planIdMapping: {},
      planId: '',
      isEnhanceStyle: false,
      payActivityInfo: {},
    };
  },
  computed: {
    openPrice() {
      if (this.allMonth) {
        // eslint-disable-next-line no-nested-ternary
        return this.info.signInfoDTO ? (this.info.signInfoDTO.firstSignPrice >= 0 ? this.info.signInfoDTO.firstSignPrice : '-') : '-';
      }
      return (this.info.current >= 0) ? this.info.current : '-';
    },
    defaultPayChannel() {
      if (env.isWeixin || env.isWechatMini) {
        return 'wechatTrust';
      }
      return 'alipay';
    },
    isOneCentRide() {
      const rideOneCentVersion = this.rideOneCentVersion() === PropVersionMap.RIDE_ONE_CENT;
      const propVersion = this.propVersion === PropVersionMap.RIDE_ONE_CENT;
      return rideOneCentVersion || propVersion;
    },
    normalStyle() {
      return {
        color: '#fff36a',
        fontSize: '0.13rem',
        fontWeight: '500',
      };
    },
    highlightStyle() {
      return {
        color: '#fff36a',
        fontSize: '0.18rem',
        // fontWeight: '700',
        fontFamily: 'DINAlternate',
      };
    },
    oneCentTip() {
      try {
        const { firstSignPrice = 0 } = (this.info && this.info.signInfoDTO) || {};
        // const { pureAmount = 0 } = this.payActivityInfo || {};

        if (!this.isOneCentRide || !firstSignPrice) return 0;
        // 当前连续包月价格 - 抖音补贴 = 到手价
        const oneCentDiscoutAmount = sub(+firstSignPrice, 9);
        return oneCentDiscoutAmount > 0 ? oneCentDiscoutAmount : 0;
      } catch {
        return 0;
      }
    },
    // signPayChannelsList() {
    //   if (this.getSignPayChannels) {
    //     return this.getSignPayChannels();
    //   }
    //   return [];
    // },
    timeBlockStyle() {
      return {
        background: 'none',
        color: '#7d3b2a',
        fontFamily: 'DIN Alternate',
      };
    },
    timeSeparatorStyle() {
      return {
        color: '#7d3b2a',
      };
    },
  },
  watch: {
    propVersion() {
      if (this.isNba) {
        return;
      }
      this.getSignChannels();
    },
    readSign(val) {
      this.isNoSign = !val;
      eventBus.$emit('isNoSign', this.isNoSign);
    },
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_button',
      contentId: 'platform_opencard_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    if (this.isNba) {
      return;
    }
    this.getSignChannels();
  },
  mounted() {
    if (this.$refs.anime) {
      this.$nextTick(() => {
        this.$refs.anime.lottie.setSpeed(1.3);
      });
    }
    applyDynamicKeyframes(this.giftList, 0.26, true, 'vip-button-ladder-slide');
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_deal',
      contentId: 'platform_deal',
      exposureTimes: 1,
      businessInfo: {},
    });
    eventBus.$on('isNoSign', (msg) => {
      if (this.isIndex) {
        Storage.setItem('isNoSign', msg);
      }
      this.isNoSign = msg;
    });
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  methods: {
    async  getSignChannels() {
      try {
        this.planId = '';
        this.payChannel = this.defaultPayChannel;
        this.payActivityInfo = {};
        const { token } = await getTokenAndKey();
        const propVersions = this.isOneCentRide ? PropVersionMap.RIDE_ONE_CENT : this.propVersion;
        const res = await getSignChannels({
          token,
          version: await getVersion(),
          systemCode: getSystemCode(),
          propVersions: [propVersions],
        });
        if (res && res.data && res.data.length > 0) {
          const temp = res.data.find((x) => x.propVersion === propVersions);
          if (temp && temp.signChannels) {
            this.signPayChannelsList = temp.signChannels;
            if (this.isOneCentRide) {
              const tiktokInfo = temp.signChannels.find((i) => i.channelCode === 'douyinTrust');
              this.payActivityInfo = tiktokInfo.payActivityInfo || {};
            }
            UBT.moduleExpose({
              pageId: 'platform_savemoneycard_page',
              categoryId: 'platform',
              moduleId: 'platform_qianyuequdao',
              contentId: 'platform_qianyuequdao',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
          if (temp && temp.planIdMapping) {
            this.planIdMapping = temp.planIdMapping;
            if (env.isWeixin || env.isWechatMini) {
              this.planId = this.planIdMapping.wechatTrust;
            }
          }
          this.isEnhanceStyle = temp.enhanceStyle;
        } else {
          this.signPayChannelsList = [];
        }
      } catch (e) {
        this.signPayChannelsList = [];
        // eslint-disable-next-line no-console
        console.log('获取支付渠道失败信息', e);
      }
    },
    changeContinuePayChannel(item) {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_qianyuequdao',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.planId = '';
      if (item.channelCode === 'wechatTrust') {
        this.planId = this.planIdMapping[item.channelCode];
      }
      this.payChannel = item.channelCode || '';
    },
    goRule() {
      Navigator.go('https://m.hellobike.com/mf/spa/u_drddcj/latest/MA2410167276498475127210024.html?activityCode=MA2410167276498475127210024');
    },
    buy() {
      Toast.show('该会员版本已停止开通，当前已购权益不受影响');
    },
    open() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_opencard_button',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      let ubtType;
      if (this.allMonth === 30) {
        ubtType = 2;
      } else {
        ubtType = 1;
      }
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_type_choose',
        categoryId: 'platform',
        businessInfo: {
          type: ubtType,
          typeandprice: `1&${this.info.signInfoDTO.firstSignPrice};2&${this.info.current}`,
        },
      });

      if (this.isNoSign) {
        this.$emit('isNoReadSign', this.allMonth ? this.payChannel : '', this.planId, this.isNba, this.payActivityInfo);
      } else if (this.info.showPopUpWindowType !== 1) {
        // 没有未支付的订单
        if (this.isNba) {
          // 联名会员
          this.$emit('open', null, this.allMonth ? ORDER_TYPE.UNION_CONTINUOUS_MONTH : ORDER_TYPE.UNION_SINGLE_MONTH, this.openPrice, this.allMonth ? this.payChannel : '', this.planId, true, {});
        } else {
          // 普通会员
          this.$emit('open', null, this.allMonth ? ORDER_TYPE.CONTINUOUS_MONTHLY : ORDER_TYPE.SINGLE_MONTH, this.openPrice, this.allMonth ? this.payChannel : '', this.planId, false, this.payActivityInfo);
        }
      } else {
        this.$emit('openDialog');
      }
    },
    sign() {
      this.isNoSign = !this.isNoSign;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_deal',
        categoryId: 'platform',
        businessInfo: {},
      });
      eventBus.$emit('isNoSign', this.isNoSign);
    },
    goRenewal() {
      Navigator.go(
        'https://m.hellobike.com/mf/spa/u_hywaxn/latest/MA2209193493443248207695231.html?activityCode=MA2209193493443248207695231',
        { isRuleLink: true },
      );
    },
    goMember() {
      Navigator.go(
        'https://m.hellobike.com/mf/spa/u_yewmjx/latest/MA2209283520078470713971794.html?activityCode=MA2209283520078470713971794',
        { isRuleLink: true },
      );
    },
    // 确定组件是否要固定在底部
    locate() {
      this.classes.fixed = true;
      this.classes.show = true;
    },
    amtWidth(list) {
      if (!list || !list.length) return '';
      return `width:${(list.length - 1) * 0.26 + 0.87}rem`;
    },
    amtDelay(list, index) {
      if (!list || !list.length) return '';
      return `animationDelay:${-(6 / list.length) * index}s`;
    },
  },
};
</script>
<style lang="less" scoped>
.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  // height: 1.24rem;
  // width: 100%;
  // z-index: 1;

  .open-gift {
    // background-image: url(https://m.hellobike.com/resource/gallery/61/ecIE1Hf9rZ.png?x-oss-process=image/quality,q_80);
    background: #ffe7af;
    background-size: 100% 100%;
    height: 0.66rem;
    width: 100%;
    position: fixed;
    bottom: 1.23rem;
    display: flex;
    border-radius: 0.16rem;

    .open-gift-left {
      flex-shrink: 0;

      .open-gift-title {
        margin-top: 0.05rem;
        margin-left: 0.16rem;
        display: flex;
        align-items: center;

        .open-gift-icon {
          margin-top: -0.1rem;
          width: 0.28rem;
          height: 0.28rem;
          background-image: url(https://m.hellobike.com/resource/gallery/192/qpSUeXojX3.png);
          background-size: 100% 100%;
        }

        .open-gift-word {
          margin-top: -0.01rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-size: 0.14rem;
          font-weight: 700;
          color: #3b1401;
          margin-left: 0.02rem;
        }

        .open-gift-img {
          margin-left: 0.02rem;
          margin-top: 0.02rem;

          img {
            width: 0.13rem;
            height: 0.13rem;
          }
        }
      }

      .open-gift-subtitle {
        font-family: PingFang SC, sans-serif;
        font-size: 0.12rem;
        margin-left: 0.2rem;
        display: flex;
        line-height: 0.22rem;

        .open-gift-text {
          font-weight: 400;
        }

        .open-gift-redText {
          color: #ff5729;
          font-weight: 500;
        }
      }
    }

    .open-gift-list {
      margin-top: 0.08rem;
      flex-wrap: nowrap;
      white-space: nowrap;
      height: 0.3rem;
      position: absolute;
      right: 0.22rem;
      flex: 1;

      .list-item {
        position: absolute;
        display: flex;
        flex: 0 0 auto;
        top: 0;
        left: 0;
        border-radius: 0.05rem;
        height: 0.3rem;
        animation: vip-button-ladder-slide 6s infinite;

        .list-img {
          img {
            height: 0.3rem;
            width: 0.87rem;
          }
        }
      }

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }
    }
  }

  .vip-button-new-container {
    background: #fff;
    box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
    border-radius: 0.2rem 0.2rem 0 0;
    z-index: 3;
    padding: 0.1rem 0.2rem 0.34rem 0.2rem;
    min-height: 1.24rem;
    width: 100%;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    position: relative;
    // position: fixed;
    // bottom: 0;

    &.show {
      opacity: 1;
    }

    &.fixed {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 10;
      box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.25);
      border-radius: 0.12rem 0.12rem 0 0;
    }

    .tab-box {
      margin-bottom: -0.06rem;
      height: 0.39rem;
      width: 100%;
      background: url(https://m.hellobike.com/resource/gallery/43/Jl-kpmRl_1211.png) top/100% 100% no-repeat;
      display: flex;
      align-items: flex-start;
      padding-left: 0.08rem;
      white-space: nowrap;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      -ms-overflow-style: none; /* IE/Edge 兼容 */

      &::-webkit-scrollbar {
        display: none;
      }

      .desc-text {
        height: 0.15rem;
        line-height: 0.15rem;
        margin: 0.1rem 0.05rem 0 0;
        color: #879099;
        font-family: "PingFang SC", sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
      }

      .channel-button {
        display: flex;
        margin-top: 0.05rem;
        background-color: #fff;
        margin-right: 0.05rem;
        align-items: center;

        &-icon {
          width: 0.16rem;
          height: 0.16rem;
        }

        &-name {
          font-family: "PingFang SC", sans-serif;
          font-size: 0.11rem;
          line-height: 0.11rem;
          font-weight: 400;
        }
      }
    }

    .continuous-channel-tab {
      .channel-button {
        max-width: 0.76rem;
        height: 0.22rem;
        border-radius: 0.04rem;

        &-icon {
          margin: 0 0.03rem 0 0.05rem;
        }

        &-name {
          color: #879099;
          margin-right: 0.06rem;
        }
      }

      .selected-channel {
        box-shadow: 0 0 0 0.01rem #d3dae0;// 替代border 解决宽度改变的问题
        position: relative;

        .channel-button-name {
          color: #000;
        }

        &::after {
          content: '';
          width: 0.091rem;
          height: 0.07rem;
          background: url('https://m.hellobike.com/resource/gallery/43/V1BULC0A_2382.png') no-repeat top/100% 100%;
          border-radius: 0 0.04rem 0 0.04rem;
          position: absolute;
          top: -0.01rem;
          right: -0.01rem;
        }
      }
    }

    .continuous-enhanceStyle {
      height: 0.47rem;
      padding: 0.02rem 0.06rem 0 0.12rem;

      .desc-text {
        color: #000;
        margin-right: 0.1rem;
      }

      .channel-button {
        height: 0.26rem;
        margin-right: 0.06rem;
        border-radius: 0.13rem;

        &-icon {
          margin: 0 0.03rem 0 0.06rem;
        }

        &-tip {
          height: 0.13rem;
          padding: 0 0.03rem;
          color: #ff5729;
          font-family: "PingFang SC", sans-serif;
          font-size: 0.1rem;
          margin-left: 0.03rem;
          border-radius: 0.03rem;
          border: 0.005rem solid #ff5729;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
        }

        &::after {
          content: " ";
          right: 0;
          display: block;
          width: 0.12rem;
          height: 0.12rem;
          margin-right: 0.07rem;
          margin-left: 0.06rem;
          background: url('https://m.hellobike.com/resource/gallery/407/4iPBkv4ftq.png') no-repeat top/100% 100%;
        }
      }

      .selected-channel {
        box-shadow: 0 0 0 0.01rem #ff5729;// 替代border 解决宽度改变的问题
        position: relative;

        &::after {
          content: '';
          width: 0.12rem;
          height: 0.12rem;
          background: url('https://m.hellobike.com/resource/gallery/407/Fx2b9OBT_selected.png') no-repeat top/100% 100%;
          border: 0;
        }
      }
    }

    .trans-tab {
      display: flex;
      margin-top: 0.06rem;
      position: relative;

      .hand {
        position: absolute;
        right: -0.2rem;
        bottom: -0.38rem;
        width: 2rem;
        height: 1rem;
        z-index: 3;
        pointer-events: none;
      }

      .trans-left {
        width: 1.45rem;
        height: 0.48rem;
        background: linear-gradient(180deg, #fff9ef 0%, #fff8e9 89.49%);
        border-radius: 0.12rem;
        margin-right: 0.15rem;
        border: 0.01rem solid #ff9240;
        text-align: center;
        filter: grayscale(100%);
        opacity: 0.6;

        .trans-left-one {
          margin-top: 0.05rem;
          font-family: PingFangSC-Medium, sans-serif;
          font-size: 0.14rem;
          color: #242729;
          font-weight: 500;

          .red-sign {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.14rem;
            color: #fa2a00;
            text-align: center;
            font-weight: 700;
            margin-right: 0.02rem;
          }

          .red-money {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.2rem;
            color: #fa2a00;
            text-align: center;
            line-height: 0.2rem;
            font-weight: 700;
          }
        }

        .trans-left-two {
          margin-top: 0.02rem;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.12rem;
          color: #879099;
          line-height: 0.12rem;
          font-weight: 400;
          text-decoration: line-through;
        }
      }

      .trans-left-oneMouth {
        background-image: linear-gradient(90deg, #fa3a00 0%, #fa8621 100%);
        box-shadow: inset 0 0.01rem 0.03rem 0 rgba(252, 122, 94, 1);
        border-radius: 0.12rem;
        width: 1.75rem;
        height: 0.48rem;
        text-align: center;

        .trans-left-one {
          margin-top: 0.02rem;
          font-family: PingFangSC-Semibold, sans-serif;
          font-size: 0.14rem;
          color: #fff;
          line-height: 0.2rem;
          font-weight: 600;

          .sign {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.14rem;
            color: #fff;
            line-height: 0.2rem;
            font-weight: 700;
            margin-right: 0.02rem;
          }

          .big-money {
            font-size: 0.2rem;
            line-height: 0.24rem;
            font-family: "DIN Alternate", sans-serif;
          }
        }

        .trans-left-two {
          opacity: 0.7;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.12rem;
          color: #fff;
          font-weight: 400;
          text-decoration: line-through;
        }
      }

      .trans-right-oneMouth {
        width: 1.45rem;
        height: 0.48rem;
        border-radius: 0.12rem;
        margin-left: 0.15rem;
        text-align: center;
        background: linear-gradient(180deg, #fff9ef 0%, #fff8e9 89.49%);
        border: 0.01rem solid #ff9240;

        .trans-right-one {
          margin-top: 0.05rem;
          font-family: PingFangSC-Medium, sans-serif;
          font-size: 0.14rem;
          color: #242729;
          font-weight: 500;

          .red-sign {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.14rem;
            color: #fa2a00;
            text-align: center;
            font-weight: 700;
            margin-right: 0.02rem;
          }

          .red-money {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.24rem;
            color: #fa2a00;
            text-align: center;
            line-height: 0.24rem;
            font-weight: 700;
          }
        }

        .trans-right-two {
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.12rem;
          color: #879099;
          line-height: 0.12rem;
          font-weight: 400;
        }
      }

      .trans-right {
        background-image: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        box-shadow: inset 0 0.01rem 0.03rem 0 rgba(252, 122, 94, 1);
        border-radius: 0.12rem;
        width: 1.75rem;
        height: 0.48rem;
        text-align: center;
        position: relative;
        filter: grayscale(100%);
        opacity: 0.6;

        .trans-right-one {
          margin-top: 0.05rem;
          font-family: PingFangSC-Semibold, sans-serif;
          font-size: 0.14rem;
          color: #fff;
          line-height: 0.2rem;
          font-weight: 500;

          .sign {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.14rem;
            color: #fff;
            line-height: 0.2rem;
            font-weight: 700;
            margin-right: 0.02rem;
          }

          .big-money {
            font-size: 0.2rem;
            line-height: 0.2rem;
            font-family: "DIN Alternate", sans-serif;
          }
        }

        .trans-right-two {
          opacity: 0.7;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.12rem;
          color: #fff;
          font-weight: 400;
        }

        .one-cent-tip {
          display: flex;
          position: absolute;
          top: -0.15rem;
          right: -0.12rem;
          background: radial-gradient(75.21% 116.47% at 84.87% 7.14%, #8c0000 0%, #000 100%);
          border-radius: 0.1rem 0.1rem 0.1rem 0;
          height: 0.21rem;
          line-height: 0.21rem;
          font-family: PingFang SC, sans-serif;
          font-weight: 600;
          color: #fff;
          padding: 0 0.07rem;

          .one-cent-tip-text {
            font-size: 0.11rem;
          }

          .one-cent-tip-amount {
            font-size: 0.14rem;
            margin-left: 0.02rem;
            font-family: DINAlternate, sans-serif;
            font-weight: 700;
            line-height: 0.19rem;

            &::before {
              content: '¥';
              font-size: 0.1rem;
              font-family: PingFang SC, sans-serif;
            }
          }
        }

        .countdown-wrapper {
          position: absolute;
          top: -0.12rem;
          right: -0.07rem;
          display: flex;
          align-items: center;
          background: linear-gradient(90deg, #ffe38e 0%, #ffec16 100%);
          height: 0.18rem;
          padding: 0 0.08rem;
          border-radius: 0.1rem 0.1rem 0.1rem 0;
          z-index: 2;

          .expire-text {
            margin-left: 0.04rem;
            font-size: 0.12rem;
            color: #7d3b2a;
            font-family: 'DIN Alternate', sans-serif;
            font-weight: 700;
          }
        }
      }
    }

    .renewal-rules {
      margin-top: 0.1rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
      color: #879099;
      text-align: center;
      display: flex;
      justify-content: center;
      z-index: 99;

      * {
        overflow: visible;
        white-space: nowrap;
      }

      .canClick {
        color: #b16652;
        z-index: 99;
      }

      img.rule-word-img {
        margin-right: 0.05rem;
        width: 0.16rem;
        height: 0.16rem;
      }
    }
  }

  .vip-button-no {
    background: #fff;
    box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
    border-radius: 0.2rem 0.2rem 0 0;
    z-index: 3;
    padding: 0.16rem 0.2rem 0.34rem 0.2rem;
    height: 1.41rem;
    width: 100%;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    position: fixed;
    bottom: 0;

    .vip-button-img {
      margin-bottom: 0.14rem;
      display: flex;
      justify-content: center;

      img {
        width: 3.75rem;
        height: 0.26rem;
      }
    }

    .vip-button-block {
      display: flex;
      justify-content: space-between;

      .vip-left-button {
        background: #eef2f5;
        border: 0.005rem solid #e4e8eb;
        border-radius: 0.26rem;
        width: 1.45rem;
        height: 0.52rem;
        text-align: center;
        color: #879099;

        .trans-left-one {
          margin-top: 0.06rem;
          font-family: PingFangSC-Semibold, sans-serif;
          font-size: 0.14rem;
          line-height: 0.2rem;
          font-weight: 500;

          .sign {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.14rem;
            line-height: 0.2rem;
            font-weight: 700;
            margin-right: 0.02rem;
          }

          .big-money {
            font-size: 0.2rem;
            line-height: 0.2rem;
            font-family: "DIN Alternate", sans-serif;
          }
        }

        .trans-left-two {
          opacity: 0.7;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.12rem;
          font-weight: 400;
          text-decoration: line-through;
        }
      }

      .vip-right-button {
        background: #bcc4cc;
        border-radius: 0.26rem;
        width: 1.75rem;
        height: 0.52rem;
        text-align: center;
        position: relative;

        .trans-right-one {
          margin-top: 0.06rem;
          font-family: PingFangSC-Semibold, sans-serif;
          font-size: 0.14rem;
          color: #fff;
          line-height: 0.2rem;
          font-weight: 600;

          .sign {
            font-family: "DIN Alternate", sans-serif;
            font-size: 0.14rem;
            color: #fff;
            line-height: 0.2rem;
            font-weight: 700;
            margin-right: 0.02rem;
          }

          .big-money {
            font-size: 0.24rem;
            line-height: 0.24rem;
            font-family: "DIN Alternate", sans-serif;
          }
        }

        .trans-right-two {
          opacity: 0.7;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.12rem;
          color: #fff;
          font-weight: 400;
        }
      }
    }
  }

  .continuous-month-channel-tab {
    position: fixed;
    bottom: 1.23rem;
    height: 0.66rem;
    background-color: #ffe7af;
    width: 100%;
    padding: 0.1rem 0.2rem;

    .channel {
      line-height: 0.3rem;
      height: 0.3rem;
      border-radius: 0.2rem;
      text-align: center;
      width: 1.2rem;
      background-color: darkgreen;
      color: #fff;
    }
  }

  .tiktok-pay-box {
    // position: absolute;
    // top: -0.4rem;
    // left: 0;
    // right: 0;
    margin-bottom: -0.2rem;
    width: 100%;
    height: 0.56rem;
    background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
    box-shadow: 0 -0.1rem 0.2rem 0 rgba(0, 0, 0, 0.12);
    border-radius: 0.2rem 0.2rem 0 0;

    .tiktok-icon {
      position: absolute;
      top: -0.04rem;
      left: 0.12rem;
      width: 0.39rem;
      height: 0.46rem;
    }

    .tiktok-content {
      display: flex;
      padding-top: 0.08rem;
      margin-left: 0.58rem;
      align-items: center;
      gap: 0.12rem;

      .tiktok-discount-title {
        height: 0.15rem;
      }

      .tiktok-discount-content {
        display: flex;
        align-items: baseline;
        gap: 0.05rem;
        width: 1.84rem;

        .discount-text {
          color: #fff;
          font-size: 0.13rem;
          font-weight: 500;
          line-height: 1;
        }

        .discount-price {
          height: 0.21rem;
          display: flex;
          align-items: baseline;
          line-height: 1;
        }
      }
    }
  }
}

.free-rights-version {
  .bottom-container {
    .vip-button-new-container {
      .trans-tab {
        .trans-left {
          background: #fff6ea;
          border-radius: 0.12rem;
          border: none !important;

          .trans-left-two {
            font-size: 0.1rem;
          }
        }
      }

      .trans-left {
        .trans-left-one {
          .red-sign,
          .red-money {
            color: #242729;
          }
        }
      }

      .trans-right {
        box-shadow: unset;
        background: linear-gradient(96deg, #151931 -2.07%, #151931 56.05%, #22306b 92.74%);
        color: #fff0e9;
        position: relative;

        &::before {
          content: '';
          z-index: 2;
          position: absolute;
          display: inline-block;
          left: -15%;
          top: 0;
          width: 1rem;
          height: 100%;
          opacity: 0.7;
          transform: skewX(160deg);
          background: linear-gradient(90deg, transparent, #fff 30%, transparent);
          animation: move-light 3s infinite;
          pointer-events: none;
        }

        @keyframes move-light {
          100% {
            left: 125%;
          }
        }

        .trans-right-one {
          color: #fff0e9;
          font-weight: 600;

          .sign {
            color: #fff0e9;
          }
        }

        .trans-right-two {
          opacity: 0.8;
          font-size: 0.1rem;
          color: #fff0e9;
        }
      }

      .renewal-rules {
        .normal {
          color: #879099;
        }

        .canClick {
          color: #242729;
          z-index: 99;
        }
      }
    }
  }
}
</style>
